import Bb from 'backbone';
import _ from 'lodash';

import BaseFormView from '../../../components/BaseForm';
import template from './index.jst';
import Preloader from '../../../../utils/Preloader/index';

const errorMappingServerToClient = {
	'Login or password are wrong': 'Email or Password is incorrect'
};

class LinkAccountView extends BaseFormView {

	get template() {
		return template;
	}

	get className() {
		return "onboarding-form onboarding-link-account";
	}

	ui() {
		return {
			form           : '.js-link-account-form',
			login          : '.js-login',
			password       : '.js-password',
			link           : '.js-link',
			cancel         : '.js-cancel',
			forgot_password: '.js-forgot-password'
		};
	}

	events() {
		return {
			'click @ui.link'           : 'onClickNext',
			'click @ui.cancel'         : 'onClickCancel',
			'click @ui.forgot_password': 'onClickForgotPassword',
			'change @ui.form'          : 'onChangeForm'
		};
	}

	initialize() {
		this.onboarding = this.getOption('onboarding');
		this.model = new Bb.Model();

		this.setListeners();
		this.setDefaultValues();
	}

	setListeners() {
		this.listenTo(
			this.onboarding,
			'user:check_credentials:success',
			this.onUserCheckCredentialsSuccess
		);

		this.listenTo(
			this.onboarding,
			'user:check_credentials:fail',
			this.onUserCheckCredentialsFail
		);
	}

	setDefaultValues() {
		this.model.set({
			game_title: this.onboarding.get('game_title'),
			login   : '',
			password: '',
			errors  : undefined
		});
	}

	changeField(field_name) {
		this.model.set({
			[field_name]: this.getFormValues()[field_name]
		});

		const errors = this.validateField(field_name);
		const is_errors = !_.isUndefined(errors);
		const is_need_to_render = is_errors || (this.model.get('is_errors') && !is_errors);


		this.model.set({
			is_errors,
			errors: {
				...this.model.get('errors'),
				[field_name]: errors
			}
		});

		if (is_need_to_render) {
			this.render();
		}
	}

	async submit() {
		const errors = this.validate();

		if (errors) {
			this.attachValidationErrors(errors);
			return false;
		}

		Preloader.show();

		await this.onboarding.checkExistingUserAccountCredentials({
			login: this.model.get('login'),
			password: this.model.get('password')
		});

		Preloader.hide();
	}

	onUserCheckCredentialsSuccess() {
		this.onboarding.set({
			current_step: 'MatchStartPlaying',
			MatchStartPlaying_back_url: 'LinkAccount'
		});

	}

	onUserCheckCredentialsFail(errors) {
		const parsed_errors = errors.map(
			error => errorMappingServerToClient[error.text] || error.text
		);
		this.attachValidationErrors({
			server_side: parsed_errors
		});
	}

	onClickCancel(e) {
		e.preventDefault();
		this.onboarding.set({
			current_step: this.onboarding.get('LinkAccount_back_url')
		});
	}

	onClickForgotPassword(e) {
		e.preventDefault();

		this.onboarding.set({
			current_step: 'PasswordReset',
			PasswordReset_back_url: 'LinkAccount'
		});
	}

	getFormValues() {
		return {
			login   : this.getUI( 'login' ).val(),
			password: this.getUI( 'password' ).val()
		};
	}

	validationRules() {
		return {
			login:  {
				presence: {
					allowEmpty: false,
					message: "User email address is required"
				},
				email: {
					message: "User email address must be a valid email format"
				}
			},
			password: {
				presence: {
					allowEmpty: false,
					message: "Password is required"
				}
			}
		}
	}
}

export default LinkAccountView;